export default __webpack_public_path__ + "static/media/Snd_g2.10f59561.mp3";